import '@emotion/react';
import styled from '@emotion/styled';
import tokens from '@lacedltd/design-tokens';
import { mediaQuery } from '../../../../helpers/media.js';
import * as Typography from '../../../atoms/Typography/Typography.js';
import Button$1 from '../../../atoms/Button/Button.js';
import { ContentContainer } from '../CookieBanner.styles.js';

var _a, _b, _c;
var Container = styled(ContentContainer)((_a = {
        display: "flex",
        flexDirection: "column",
        overflow: "auto"
    },
    _a[mediaQuery.m.min] = {
        display: "grid",
        gridTemplateAreas: "'header footer' 'content footer'",
    },
    _a));
var Content = styled.div({
    paddingRight: tokens.spacing[7],
    a: {
        textTransform: tokens.textCase.none,
    },
});
var ContentText = styled(Typography.Text)({
    marginBottom: "0",
    color: tokens.color.airJordan.p,
});
var Button = styled(Button$1)((_b = {},
    _b[mediaQuery.m.min] = {
        width: "100%",
    },
    _b));
var Footer = styled.footer((_c = {
        width: "100%",
        display: "grid",
        gridAutoFlow: "row",
        gap: tokens.spacing[6],
        backgroundColor: "white",
        marginTop: "auto",
        paddingTop: tokens.spacing[7]
    },
    _c[mediaQuery.m.min] = {
        paddingTop: 0,
        paddingLeft: tokens.spacing[7],
        marginTop: tokens.spacing[9],
        gridArea: "footer",
    },
    _c));

export { Button, Container, Content, ContentText, Footer };
//# sourceMappingURL=SimpleCookieForm.styles.js.map
